<div class="container d-flex justify-content-center">
    <div class="banner-overlap">
        <div class="d-flex justify-content-between align-items-center mb-26">
            <h2 class="section-heading">Explore Tenders By Authority</h2>
            <a class="cursor" href="{{baseUrl + '/all-tenders/authorities'}}">
                <div class="ml-auto d-flex align-items-center ">
                    <span class="view-all-outline-btn border-0 ms-3" title="All Tenders Closing Soon List">
                        View All
                    </span>
                </div>
            </a>
        </div>
        <div class="phone-width">
            <app-slick-slider [tenders]="closingSoonTenders" [dataType]="'Authority'"
                [type]="'Authority'"></app-slick-slider>
        </div>
    </div>
</div>